import { businessKey } from 'queryKeys';

const SKAN_SCHEMES = 'skanSchemes';
const HISTORY = 'history';
const MUTATION_EXPORT = 'export';
const skanSchemesQuery = businessKey.query(SKAN_SCHEMES);

export const grid = skanSchemesQuery.grid();
export const history = skanSchemesQuery.exact(HISTORY);
export const mutations = skanSchemesQuery.mutations();

export const update = mutations.update();
export const exportKey = mutations.mutate(MUTATION_EXPORT);
